import angular from 'angular';
import gettext from 'angular-gettext';
import toastr from 'angular-toastr';
import ProductResource from '../../cmsCore/ProductsModules/ProductResource';
import ProductCategoryResource from '../../cmsCore/ProductsModules/ProductCategoryResource';
import deleteElementDialog from '../../cmsCore/DeleteElementModal/deleteElement';

let productsFormPage = angular.module('cms.products.add', [ProductResource, ProductCategoryResource, gettext, toastr, deleteElementDialog])
    .component('productsFormPage', {
        template: require('./templates/productsForm.html'),
        controller: function (
            $scope,
            ProductResource,
            ProductCategoryResource,
            $state,
            $stateParams,
            $http,
            $q,
            toastr,
            gettextCatalog,
            ACLService,
            deleteElementDialog,
            CONFIG,
            SaveWarning,
            $element
        ) {

            /** @ngInject */

            if($stateParams.id) {
                ProductResource.find({id: $stateParams.id},
                    response => {
                        this.product = response;
                        SaveWarning.watch(response, this.product, $scope, $element);
                    }
                );
            } else {
                this.product = {
                    attachments: [],
                    photos: []
                };
                SaveWarning.watch(this.product, this.product, $scope, $element);
            }

            this.matchRoles = ACLService.matchRoles;

            this.errors = {};
            this.pending = false;

            /**
             * Broadcast slug recalculation request
             */
            this.updateSlug = function() {
                if(!this.product.id || !this.product.slug) {
                    $scope.$broadcast('slug.recalc');
                }
            };

            /**
             * Actions to validate slug
             * Returns promise;
             * @param data
             */
            this.validateSlug = function(data) {

                this.errors.slug = [];
                if(!data) {
                    return $q.when([]);
                }

                let productResourcePromise = ProductResource.findAll({slug_strict: data}).$promise;

                productResourcePromise.then((response) => {

                    angular.forEach(response.data, function (value) {
                       if (value.id !== this.product.id) {
                           this.errors.slug = [gettextCatalog.getString('This value is already used')];
                       }
                    }, this);
                });

                return productResourcePromise;
            };

            ProductCategoryResource.findAll({}, (data) => {
                this.productCategories = data.data;
            });

            this.onErrorMessage = function () {
                return toastr.error(
                    gettextCatalog.getString('Please correct form errors and try again.', {name: this.product.name}),
                    gettextCatalog.getString('Validation Errors')
                );
            };

            /**
             * Submit products
             */
            this.create = () => {
                this.pending = true;
                ProductResource.save(this.product,
                    response => {
                        this.product = {};
                        this.errors = {};
                        SaveWarning.watch(response, this.product, $scope, $element);
                        toastr.success(
                            gettextCatalog.getString('Product {{name}} added!', {name: this.product.name}),
                            gettextCatalog.getString('Success')
                        );
                        goToReturnState();
                        this.pending = false;
                    },
                    response => {
                        if(response.status === 400){
                            this.errors = response.data;
                            this.onErrorMessage();
                        }
                        this.pending = false;
                    }
                );
            };

            /**
             * Submit products
             */
            this.update = () => {
                this.pending = true;
                ProductResource.update(this.product,
                    response => {
                        this.product = {};
                        this.errors = {};
                        SaveWarning.watch(response, this.product, $scope, $element);
                        toastr.success(
                            gettextCatalog.getString( 'Product {{name}} saved!', {name: this.product.name}),
                            gettextCatalog.getString('Success')
                        );
                        goToReturnState();
                        this.pending = false;
                    },
                    response => {
                        if(response.status === 400){
                            this.errors = response.data;
                            this.onErrorMessage();
                        }
                        this.pending = false;

                    }
                )
            };

            this.updateOrCreate = () => {
                if (this.product.id) {
                    return this.update(false);
                } else {
                    return this.create(false);
                }
            };

            this.delete = () => {
                this.pending = true;
                ProductResource
                    .delete({id: this.product.id}, response => {
                        toastr.success(
                            gettextCatalog.getString('Product {{name}} deleted!', {name: this.product.name}),
                            gettextCatalog.getString('Success')
                        );
                    goToReturnState();
                    this.pending = false;
                    })
            };

            this.confirmDelete = () => {
                let removeMessage = gettextCatalog.getString("Are you sure that you want to delete the \"{{name}}\" product?", {name: this.product.name});
                deleteElementDialog.open(removeMessage).then(() => {
                    this.delete();
                }).catch( () => {});
            };

            // @tip wyrzucając tą funkcję do innego pliku pozbędziemy się 2 zależności - $http i CONFIG
            this.orderStatistics  = () => {
                if ($stateParams.id) {
                    return $http.get(CONFIG.API_URL + '/product-stats/order/' + $stateParams.id + '/30');
                }
            };

            this.cancel = () => goToReturnState();

            function goToReturnState() {
                SaveWarning.stopWatch();
                if ($stateParams.returnState) {
                    $state.go($stateParams.returnState.name, $stateParams.returnState.params)
                } else {
                    $state.go('products', {})
                }
            }

            $scope.$on('save.object', () => {
                this.updateOrCreate();
            })

        }
    });

export default productsFormPage.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Products/ProductsFormPage.js